import React, { useState, useEffect } from "react";
import { Box, Typography, Chip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { fetchData } from "../BaseUrl";

const AcademicCountdown = () => {
  const [daysLeft, setDaysLeft] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchEndDate = async () => {
      try {
        const res = await fetchData("admin/website-config/list?category=academic");
        if (res?.data) {
          const configs = Array.isArray(res.data) ? res.data : [];
          const yearEnd = configs.find(c => c.configKey === "academic_year_end");
          if (yearEnd?.configValue) {
            const end = new Date(yearEnd.configValue);
            setEndDate(end);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const diff = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
            setDaysLeft(diff);
          }
        }
      } catch (_) {
        // Fallback: show countdown to May 31
        const fallbackEnd = new Date(`${new Date().getFullYear()}-05-31`);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const diff = Math.ceil((fallbackEnd - today) / (1000 * 60 * 60 * 24));
        setDaysLeft(diff);
        setEndDate(fallbackEnd);
      }
    };
    fetchEndDate();
  }, []);

  if (dismissed || daysLeft === null || daysLeft < 0) return null;

  const isUrgent = daysLeft <= 30;
  const isCritical = daysLeft <= 7;

  const bgColor = isCritical ? "#fef2f2" : isUrgent ? "#fffbeb" : "#eff6ff";
  const textColor = isCritical ? "#dc2626" : isUrgent ? "#d97706" : "#1d4ed8";
  const borderColor = isCritical ? "#fecaca" : isUrgent ? "#fde68a" : "#bfdbfe";

  return (
    <Box sx={{
      backgroundColor: bgColor,
      border: `1px solid ${borderColor}`,
      borderRadius: "10px",
      px: 2, py: 1.2,
      display: "flex", alignItems: "center", justifyContent: "space-between",
      mb: 2
    }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <AccessAlarmIcon sx={{ color: textColor, fontSize: "20px" }} />
        <Typography sx={{ fontSize: "13.5px", color: textColor, fontWeight: 500 }}>
          Academic Year ends on{" "}
          <strong>{endDate ? endDate.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : ""}</strong>
        </Typography>
        <Chip
          label={`${daysLeft} day${daysLeft !== 1 ? "s" : ""} left`}
          size="small"
          sx={{ backgroundColor: textColor, color: "#fff", fontWeight: 700, fontSize: "11px" }}
        />
      </Box>
      <IconButton size="small" onClick={() => setDismissed(true)} sx={{ color: textColor }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default AcademicCountdown;
